import React, { useState } from 'react';
import { Modal, Form, Input, Button, DatePicker, message, Spin, notification } from 'antd';
import { UserOutlined, MailOutlined, CalendarOutlined, PhoneOutlined, ClockCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';
import Select from 'react-select';
import { post } from '../../services/ApiService';
// import './index.css'; 

const VaccineManualBooking = ({ isVisible, onClose, item}) => {
    const [bookingDate, setBookingDate] = useState(null);
    const [bookingTime, setBookingTime] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(null);

    // Time options for the select dropdown
    const timeOptions = [
        { value: '09:00', label: '09:00 AM' },
        { value: '09:15', label: '09:15 AM' },
        { value: '09:30', label: '09:30 AM' },
        { value: '09:45', label: '09:45 AM' },
        { value: '10:00', label: '10:00 AM' },
        { value: '10:15', label: '10:15 AM' },
        { value: '10:30', label: '10:30 AM' },
        { value: '10:45', label: '10:45 AM' },
        { value: '11:00', label: '11:00 AM' },
        { value: '11:15', label: '11:15 AM' },
        { value: '11:30', label: '11:30 AM' },
        { value: '11:45', label: '11:45 AM' },
        { value: '12:00', label: '12:00 PM' },
        { value: '12:15', label: '12:15 PM' },
        { value: '12:30', label: '12:30 PM' },
        { value: '12:45', label: '12:45 PM' },
        { value: '13:00', label: '01:00 PM' },
        { value: '13:15', label: '01:15 PM' },
        { value: '13:30', label: '01:30 PM' },
        { value: '13:45', label: '01:45 PM' },
        { value: '14:00', label: '02:00 PM' },
        { value: '14:15', label: '02:15 PM' },
        { value: '14:30', label: '02:30 PM' },
        { value: '14:45', label: '02:45 PM' },
        { value: '15:00', label: '03:00 PM' },
        { value: '15:15', label: '03:15 PM' },
        { value: '15:30', label: '03:30 PM' },
        { value: '15:45', label: '03:45 PM' },
        { value: '16:00', label: '04:00 PM' },
        { value: '16:15', label: '04:15 PM' },
        { value: '16:30', label: '04:30 PM' },
        { value: '16:45', label: '04:45 PM' },
        { value: '17:00', label: '05:00 PM' },
        { value: '17:15', label: '05:15 PM' },
        { value: '17:30', label: '05:30 PM' }
    ];

    const disabledDate = (current) => {
        return current && (current < moment().startOf('day') || current.day() === 0 || current.day() === 6);
    };

    // Handle form submission
    const handleFinish = async (values) => {
        try {
            const finalValues = {
                ...values,
                bookingDate: bookingDate,
                bookingTime: bookingTime,
                itemId: item?._id
            };
            await ManualBooking(finalValues);
        } catch (error) {
            message.error('Failed to send email. Please try again.');
        }
        onClose();
    };

    const ManualBooking = async (values) => {
        setConfirmLoading(true);
        try {
          const Body = {
            item: values.itemId,
            name: values.name,
            email: values.email,
            phone: values.phone,
            bookingDate: values.bookingDate,
            bookingTime: values.bookingTime,
            additionalInfo: values.additionalInfo,
          };
          const res = await post(`api/booking/vaccine/manual`, Body);
          setConfirmLoading(false);
    
          if (res?.success) {
            notification.success({
              message: 'Success',
              description: 'Your email sent successfully! Our team will get back to you soon.',
              duration: 4,
              placement: 'topRight',
            });
            onClose();
    
          } else {
            notification.success({
                message: 'Failed',
                description: 'Failed to send email. Please try again!',
                duration: 4,
                placement: 'topRight',
            });
          }
        } catch (error) {
          setConfirmLoading(true);
          console.error(error);
          notification.success({
                message: 'Failed',
                description: 'Failed to send email. Please try again!',
                duration: 4,
                placement: 'topRight',
            });
        }
      };

    // Handle date change
    const handleDateChange = (date) => {
        setBookingDate(date);
    };

    // Handle time change
    const handleTimeChange = (selectedOption) => {
        setBookingTime(selectedOption ? selectedOption.value : null);
    };

    return (
        <Modal
            title=""
            open={isVisible}
            onCancel={onClose}
            footer={null}
            confirmLoading={confirmLoading}
            destroyOnClose
            width={600}
        >
            <p className='mt-8 text-danger'>
                {`Due to limited stock, the ${item?.name} requires a scheduled appointment.
                Please complete and submit the form below. Once we receive your details, a member of our team will contact you to arrange a suitable appointment based on current availability.`}
            </p>
            <h6>Dear My Private Chemist,</h6>
            <Form
                layout="horizontal"
                onFinish={handleFinish}
                style={{ maxWidth: '100%' }}
            >
                <Form.Item
                    name="additionalInfo"
                    initialValue="I am interested in booking the travel vaccine I have selected, which requires scheduled appointment. Could you please confirm your availability?"
                    style={{ marginBottom: '16px', borderTop: '0px', borderLeft: '0px', borderRight: '0px' }}
                >
                    <Input.TextArea 
                        rows={4} 
                        placeholder="You can add more details here if needed."
                    />
                </Form.Item>

                <Form.Item
                    label="Name"
                    name="name"
                    style={{ marginBottom: '16px' }}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                   
                >
                    <Input 
                        prefix={<UserOutlined />} 
                        placeholder="Enter your name (optional)"
                         className='booking-input'
                    />
                </Form.Item>
                
                <Form.Item
                    label={
                        <span>
                            Email
                            <span className="required-asterisk" style={{ color: 'red', marginLeft: '4px' }}> *</span>
                        </span>
                    }
                    name="email"
                    rules={[
                        { required: true, message: 'Please enter your email!' },
                        { type: 'email', message: 'Please enter a valid email!' }
                    ]}
                    style={{ marginBottom: '16px' }}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    className='custom-email-form-item'
                >
                    <Input 
                        prefix={<MailOutlined />} 
                        placeholder="Enter your email"
                        className='booking-input'
                    />
                </Form.Item>


                <Form.Item
                    label="Phone"
                    name="phone"
                    style={{ marginBottom: '16px' }}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                    
                >
                    <Input 
                        type="number"
                        prefix={<PhoneOutlined />} 
                        placeholder="Enter your phone number (optional)"
                        className='booking-input'
                    />
                </Form.Item>

                <Form.Item
                    label="Preferred Date"
                    name="bookingDate"
                    style={{ marginBottom: '16px' }}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                >
                    <div className="custom-picker-wrapper">
                        <CalendarOutlined className="custom-icon" />
                        <DatePicker 
                            format="DD/MM/YYYY"
                            disabledDate={disabledDate}
                            style={{ width: '100%' }}
                            placeholder="Select a date"
                            inputReadOnly
                            className="custom-picker booking-input"
                            suffixIcon={null}  
                            onChange={handleDateChange}
                        />
                    </div>
                </Form.Item>

                <Form.Item
                    label="Preferred Time"
                    name="bookingTime"
                    style={{ marginBottom: '16px' }}
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 16 }}
                >
                    <div className="custom-picker-wrapper time-wrapper">
                        <ClockCircleOutlined className="custom-icon" />
                        <Select
                            options={timeOptions}
                            onChange={handleTimeChange}
                            placeholder="Select a time"
                            isClearable
                            isSearchable={false} 
                        
                            inputProps={{
                                readOnly: true // This will prevent the keyboard from opening
                            }}
                            styles={{
                                container: (provided) => ({
                                    ...provided,
                                    width: '100%'
                                }),
                                control: (provided) => ({
                                    ...provided,
                                    display: 'flex'
                                }),
                                valueContainer: (provided) => ({
                                    ...provided,
                                    paddingLeft: '24px'  // Adjust padding to accommodate the icon
                                }),
                                placeholder: (provided) => ({
                                    ...provided,
                                    marginLeft: '24px'  // Adjust placeholder position
                                }),
                            }}
                        />
                    </div>
                </Form.Item>


                <Form.Item style={{ textAlign: 'center' }}>
                    <Button type="primary" htmlType="submit" size="large" className="extra-large-button focus-normal">
                       {confirmLoading ? (
                            <span>
                                <Spin indicator={<LoadingOutlined className='colorload' />} /> Please Wait...
                            </span>
                        ) : (
                            'Submit'
                        )}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default VaccineManualBooking;
